import { render } from "./ApplicationItemCard.vue?vue&type=template&id=5dfc5a35&scoped=true"
import script from "./ApplicationItemCard.vue?vue&type=script&lang=js"
export * from "./ApplicationItemCard.vue?vue&type=script&lang=js"

import "./ApplicationItemCard.vue?vue&type=style&index=0&id=5dfc5a35&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dfc5a35"]])

export default __exports__